<template>
        <div>
            <b-modal size="lg"
                     button-size="sm"
                     id="NewContactPersonDialog" centered title="Neuer Kontakt"
                     @ok="handleOk"
                     @shown="dialogReset"
                     cancel-title="Abbrechen"
                     ref="NewContactPersonDialogRef"
            >
                <div class="container">

                    <div class="form-group row">

                        <label for="contactPersonFirstName" class="col-sm-2 col-form-label label-form-horizontal">Vorname</label>
                        <div class="col-sm-4">

                            <b-form-input id="contactPersonFirstName"
                                          autocomplete="off"
                                          :state="checkState('contactPersonFirstName')"
                                          type="text"
                                          v-validate="'required'"
                                          name="contactPersonFirstName"
                                          v-model.trim="contactPersonFirstName"
                                          ref="contactPersonFirstNameRef"

                            ></b-form-input>
                            <span v-show="errors.has('contactPersonFirstName')" class="error-message">Bitte den Vornamen eingeben</span>
                        </div>

                        <label for="contactPersonLastName" class="col-sm-2 col-form-label label-form-horizontal">Nachname</label>
                        <div class="col-sm-4">

                            <b-form-input id="contactPersonLastName"
                                          autocomplete="off"
                                          :state="checkState('contactPersonLastName')"
                                          type="text"
                                          v-validate="'required'"
                                          name="contactPersonLastName"
                                          v-model.trim="contactPersonLastName"
                            ></b-form-input>
                            <span v-show="errors.has('contactPersonLastName')" class="error-message">Bitte den Nachnamen eingeben</span>
                        </div>
                    </div>

                    <div class="form-group row">

                        <label for="contactPersonEmail" class="col-sm-2 col-form-label label-form-horizontal">Email</label>
                        <div class="col-sm-4">

                            <b-form-input id="contactPersonEmail"
                                          autocomplete="off"
                                          :state="checkState('contactPersonEmail')"
                                          type="text"
                                          v-validate="'required|email'"
                                          name="contactPersonEmail"
                                          v-model.trim="contactPersonEmail"
                            ></b-form-input>
                            <span v-show="errors.has('contactPersonEmail')" class="error-message">Bitte eine Email eingeben</span>
                        </div>
                        <label for="contactPersonPhone" class="col-sm-2 col-form-label label-form-horizontal">Telefon</label>
                        <div class="col-sm-4">
                            <input type="text"
                                   class="form-control"
                                   id="contactPersonPhone"
                                   v-model.trim="contactPersonPhone"
                                   name="contactPersonPhone"
                            >
                        </div>

                    </div>
                    <div class="form-group row">
                        <label for="contactPersonRole" class="col-sm-2 col-form-label label-form-horizontal">Rolle</label>
                        <div class="col-sm-4">
                            <input type="text"
                                   class="form-control"
                                   id="contactPersonRole"
                                   v-model.trim="contactPersonRole"
                                   name="contactPersonRole"
                            >
                        </div>

                    </div>
                </div>
            </b-modal>
        </div>

</template>

<script>


    export default {

        name: 'NewContactPersonDialog',

        data: function() {
            return {
                contactPersonFirstName: '',
                contactPersonLastName: '',
                contactPersonEmail: '',
                contactPersonPhone: '',
                contactPersonRole: '',
            }
        },

        methods: {

            handleOk(e) {

                e.preventDefault();

                this.$validator.validateAll().then(valid => {

                    if (valid) {

                        const contact = {
                            contactPersonFirstName: this.contactPersonFirstName,
                            contactPersonLastName: this.contactPersonLastName,
                            contactPersonEmail: this.contactPersonEmail,
                            contactPersonPhone: this.contactPersonPhone,
                            contactPersonRole: this.contactPersonRole
                        };

                        this.$refs.NewContactPersonDialogRef.hide();
                        this.$emit('added', contact);
                    }
                });
            },

            dialogReset() {
                this.contactPersonFirstName = '';
                this.contactPersonLastName = '';
                this.contactPersonEmail = '';
                this.contactPersonPhone = '';
                this.contactPersonRole = '';
                this.$validator.reset();
                this.$refs.contactPersonFirstNameRef.focus();
            },

            openDialog() {
                this.$refs.NewContactPersonDialogRef.show();
            },

            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            }
        }
    }

</script>

<style scoped lang="scss">

</style>